export default __webpack_public_path__ + "static/media/VinLocation.7b44c8b2.jpg";